export enum ROLE {
  ADMIN,
  AUTHOR,
  VISITOR,
}
